import { Outlet } from 'react-router';
import { TRPCProvider } from '../providers/trpc-provider';
import { Toaster } from '../components/ui/sonner';
import '../globals.css';
import { syncAuthFromCookie } from '../lib/auth';

// Hydrate localStorage from cross-domain cookies before any auth checks run
syncAuthFromCookie();

export function RootLayout() {
  return (
    <TRPCProvider>
      <Outlet />
      <Toaster />
    </TRPCProvider>
  );
}
